module.exports = "Show or hide different types of forest change<br> by clicking the toggle switches ";


//////////////////
// WEBPACK FOOTER
// ./src/js/tour/tourTypesFilter.html
// module id = 33
// module chunks = 0